import triggerTracking from '@blueprint/tracking';

export const trackSeeAllUKNewHomes = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'new_homes',
        eventAction: 'clickthrough',
        eventLabel: 'browse_all_properties_new_homes'
    });
};

export const trackIndividualLocationNewHomes = (location: string) => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'new_homes',
        eventAction: 'clickthrough',
        eventLabel: `browse_new_homes_${location.toLowerCase()}`
    });
};
